const style = {
  card: {
    height: 'calc(100vh - 93px)',
  },
};

export default style;
